var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-box',{attrs:{"bg":"red-100","border":"red-200","color":"red-300","px":"4","py":"3","mt":"4","rounded":""}},[_vm._v(" Impossible d'effectuer cette opération. Aucun validateur des transactions financières n'a été défini. ")])}
var staticRenderFns = []

export { render, staticRenderFns }